/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { providePrimeNG } from 'primeng/config';
import { SuraPreset } from './sura-preset';

/**
 * Configuración de PrimeNG
 * 
 * zIndex: Configuración centralizada de z-index para overlays.
 * Esto resuelve problemas de stacking context donde calendarios
 * y dropdowns quedan detrás de otros elementos del formulario.
 */
export const primeConfig = [
  providePrimeNG({
    ripple: true,
    zIndex: {
      modal: 1100,    // Diálogos
      overlay: 2000,  // Calendarios, Dropdowns, Tooltips
      menu: 1000,
      tooltip: 3000
    },
    theme: {
      preset: SuraPreset,
      options: {
        darkModeSelector: '.dark',
        cssLayer: {
          name: 'primeng',
          order: 'tailwind-base, primeng, tailwind-utilities'
        }
      }
    }
  })
];
